"use client";

import { useState } from "react";
import { Plus } from "lucide-react";

function normalizeHyphens(text: string) {
  return text.replace(/[\u2013\u2014]/g, "-");
}

export default function FaqAccordion({
  faqs,
}: {
  faqs: { q: string; a: string }[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="mt-7 grid grid-cols-1 gap-3 sm:gap-4">
      {faqs.map((f, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div
            key={idx}
            className="rounded-2xl bg-white ring-1 ring-slate-200 shadow-sm transition-all duration-200 ease-out hover:shadow-md hover:ring-slate-300"
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : idx)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 p-4 sm:p-5 text-left"
            >
              <span className="text-sm sm:text-base font-semibold text-slate-900">
                {normalizeHyphens(f.q)}
              </span>
              <span
                className={`shrink-0 grid place-items-center h-8 w-8 rounded-full ring-1 ring-slate-200 transition-all duration-200 ease-out ${isOpen ? "bg-brand-primary ring-brand-primary" : "bg-white"}`}
              >
                <Plus
                  className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? "rotate-45 text-white" : "rotate-0 text-brand-primary"}`}
                />
              </span>
            </button>
            <div
              className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out px-4 sm:px-5 ${isOpen ? "grid-rows-[1fr] opacity-100 pb-4 sm:pb-5" : "grid-rows-[0fr] opacity-0 pb-0"}`}
            >
              <div className="overflow-hidden">
                <p className="text-slate-700 text-sm leading-relaxed">
                  {normalizeHyphens(f.a)}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
